import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { GET_ADMIN_ANNOUNCEMENT_CONFIG_URL } from '../../constants/apiUrls';
import { GET_ADMIN_ANNOUNCEMENT_CONFIG_QUERY_KEY } from '../../constants/queryKeys';
import { useCustomQuery } from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface AnnouncementConfigResponse {
  titleEnabled: boolean;
  descriptionEnabled: boolean;
  priorityEnabled: boolean;
  documentEnabled: boolean;
  validityPeriodEnabled: boolean;
  recipientSelectionEnabled: boolean;
  titleLength: number;
  descriptionLength: number;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (res: AnnouncementConfigResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  announcementType: string;
  enabled: boolean;
}

export const useGetAnnouncementConfig = ({
  onSuccess,
  onError,
  announcementType,
  enabled,
}: Input) => {
  const getAnnouncementConfig = async () => {
    const res = await axiosClient.get<AnnouncementConfigResponse>(
      GET_ADMIN_ANNOUNCEMENT_CONFIG_URL(announcementType)
    );
    return res.data;
  };

  return useCustomQuery(
    GET_ADMIN_ANNOUNCEMENT_CONFIG_QUERY_KEY.concat(announcementType),
    getAnnouncementConfig,
    {
      onSuccess,
      onError,
      enabled,
    }
  );
};
